import gql from 'graphql-tag'
import { GQL_USER_DEFAULT_FIELDS } from '@/components/users/graphql/graphql.const.ts'

export const ReleaseUserMutation = gql`
    mutation ReleaseUser($userId: Uint!) {
      user: releaseUser (userId: $userId) {
        ${GQL_USER_DEFAULT_FIELDS}
      }
    }
  `
export const RestrictUserMutation = gql`
    mutation RestrictUser($userId: Uint!) {
      user: restrictUser (userId: $userId) {
        ${GQL_USER_DEFAULT_FIELDS}
      }
    }
  `

export const DeleteUserMutation = gql`
  mutation DeleteUser($userId: Uint!) {
    user: deleteUser (userId: $userId) {
      ${GQL_USER_DEFAULT_FIELDS}
    }
  }
`

export const RestoreUserMutation = gql`
  mutation RestoreUser($userId: Uint!) {
    user: restoreUser (userId: $userId) {
      ${GQL_USER_DEFAULT_FIELDS}
    }
  }
`

export const HideUserMutation = gql`
  mutation HideUser($userId: Uint!) {
    user: hideUser (userId: $userId) {
      ${GQL_USER_DEFAULT_FIELDS}
    }
  }
`

export const ShowUserMutation = gql`
  mutation ShowUser($userId: Uint!) {
    user: showUser (userId: $userId) {
      ${GQL_USER_DEFAULT_FIELDS}
    }
  }
`

export const CreateOrUpdateUserMutation = gql`
  mutation CreateOrUpdateUser ($input: CreateOrUpdateUserInput!) {
    user: createOrUpdateUser (input: $input) {
      ${GQL_USER_DEFAULT_FIELDS}
    }
  }`

export const AuthorizeUserMutation = gql`
  mutation AuthorizeUser($input: AuthorizeUserInput!) {
    user: authorizeUser (input: $input) {
      id
      roleId
      username
      firstname
      lastname
    }
  }
`

export const UnAuthorizeUserMutation = gql`
  mutation UnAuthorizeUser {
    user: unauthorizeUser {
      succeed
    }
  }
`

/*
  deleteUser(userId: Uint!): User! @hasRole(role: [SuperUser]) # Read comment for createOrUpdateProject if want add more roles
  restoreUser(userId: Uint!): User! @hasRole(role: [SuperUser]) # Read comment for createOrUpdateProject if want add more roles
  hideUser(userId: Uint!): User! @hasRole(role: [SuperUser]) # Read comment for createOrUpdateProject if want add more roles
  showUser(userId: Uint!): User! @hasRole(role: [SuperUser]) # Read comment for createOrUpdateProject if want add more roles

 */
